export default "__VITE_ASSET__0d83f0a2__"